<template>
    <CModal :title="title" :show.sync="importModal" centered fade class="disable-footer disable-header"
        :closeOnBackdrop="false">
        <div class="popup-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button type="button" @click="handleClose">
                <CIcon name="cil-x" />
            </button>
        </div>
        <br />
        <CSelect v-if="isClientSelectVisible()" label="Client" placeholder="Select a client" :options="clientList"
            horizontal :value.sync="selectedClient" id="select" />
        <slot></slot>
        <div class="form-group form-row">
            <label class="col-form-label col-sm-3">Upload File</label>
            <CCol sm="6">
                <CInputFile :disabled="progressValue !== 0" @change="(f, event) => {
                    files = f;
                    invalidFileExt = false;
                    largeFile = false;
                }
                    "
                    :description="'Choose a csv file and hit upload. Max file size: 100MB. \nUse the template file to import'"
                    id="fileInput" accept=".csv" />
            </CCol>
            <CCol class="pr-0">
                <CLink @click="downloadTemplate">Template File</CLink>
            </CCol>
        </div>

        <CRow>
            <CCol sm="3"></CCol>
            <CCol class="custom-col">
                <div v-if="invalidFileExt" class="invalid-feedback mb-3 mt-0" style="display: block !important">
                    Invalid file extension, Please upload a
                    <strong>csv</strong> file
                </div>
                <div v-if="largeFile" class="invalid-feedback mb-3 mt-0" style="display: block !important">
                    File size is to large, Please upload a file less than
                    <strong>100MB</strong>
                </div>
            </CCol>
        </CRow>

        <template v-if="uploadStarted">
            <div class="float-right">{{ progressValue }}%</div>
            <CProgress :value="progressValue" size="sm" animated color="success" style="height: 5px; width: 100%"
                class="mb-3" />
        </template>
        <h6 v-if="showToast" class="error">
            Something went wrong while trying to upload the file, sign out and
            try again in a new tab.
        </h6>
        <h6 v-if="progressValue === 100">
            File uploaded to our server. We will notify you once it is imported
            to the database
        </h6>

        <div class="inactive-modal-response">
            <template v-if="progressValue === 100">
                <CButton type="submit" color="secondary" class="m-1 float-right" @click="handleClose">Ok</CButton>
            </template>
            <template v-if="!uploadStarted">
                <CButton type="submit" color="primary" class="m-1 float-right" :disabled="!files && !selectedClient"
                    @click="handleFileUpload">Upload</CButton>
                <CButton type="submit" color="secondary" class="m-1 float-right" @click="handleClose">Cancel</CButton>
            </template>
        </div>
    </CModal>
</template>

<script>
import { storeData } from "../../store";
import gql from "graphql-tag";

const FILE_UPLOAD_STATUS = gql`
    mutation (
        $fileName: String!
        $type: String!
        $client_id: uuid
        $created_on: timestamp
    ) {
        insert_spendmd_db_file_upload_status(
            objects: {
                fileName: $fileName
                type: $type
                client_id: $client_id
                created_on: $created_on
            }
        ) {
            returning {
                id
            }
        }
    }
`;
const GET_CLIENTS_LIST = gql`
    query MyQuery {
        spendmd_db_clients(where: { name: { _neq: "SpendMD" } }) {
            id
            name
        }
    }
`;
import UploadFiles from "../../utility/uploadFiles";
import XLSX from "xlsx";
import _ from "../Utility/utility";

export default {
    props: {
        modal: Boolean,
        title: String,
        type: String,
        selectClient: Boolean,
        importData: Object
    },
    data() {
        return {
            importModal: false,
            files: null,
            progressValue: 0,
            clientList: [],
            selectedClient: null,
            uploadStarted: false,
            invalidFileExt: false,
            largeFile: false,
            showToast: false,
        };
    },
    computed: {
        importProgress() {
            return this.$store.state.importProgress;
        },
        isSysAdmin() {
            return storeData.currentUserDetails.role.name === "sys_admin";
        },
        isGroupAdmin() {
            return storeData.currentUserDetails.role.name === "group_admin";
        },


    },
    watch: {
        modal() {
            this.$store.commit("set", ["importProgress", 0]);
            this.importModal = this.modal;
        },
        importProgress(val) {
            this.progressValue = val;
        },
    },
    methods: {
        downloadTemplate() {
            let templateData = null;
            if (this.type === "spend-data") templateData = SPEND_DATA_TEMPLATE;
            else if (this.type === "project") templateData = PROJECT_TEMPLATE;
            else if (this.type === "category-wise-opportunity")
                templateData = CATEGORY_WISE_OPPORTUNITY_TEMPLATE;
            else if (this.type === "vendor") templateData = VENDOR_TEMPLATE;
            else if (this.type === "categories")
                templateData = CATEGORIES_TEMPLATE;
            else if (this.type === "opportunity-data") templateData = OPPORTUNITY_TEMPLATE;
            else if (this.type === "items-data") templateData = { ...ITEMS_TEMPLATE, project_number: this.importData.project_id, client: this.importData.client_name, group: this.importData.opportunity_group, category: this.importData.opportunity_category};


            const templateArray = [];
            templateArray.push(templateData);

            const exportData = XLSX.utils.json_to_sheet(templateArray);
            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, exportData, "Data");
            XLSX.writeFile(workBook, `${this.type}-template.csv`);
        },
        isClientSelectVisible() {
            if (this.selectClient) {
                if (this.isSysAdmin || this.isGroupAdmin) return true;
                else return false;
            } else {
                return false;
            }
        },
        handleFileUpload() {
            if(this.type == "items-data"){
                this.selectedClient = this.importData.client_id;
            }
            if (
                this.selectedClient == null ||
                this.selectedClient == false ||
                this.selectedClient == undefined ||
                this.selectedClient == ""
            ) {
                this.showToast = true;
                return;
            } else {
                // Extracting extension from file name
                const re = /(?:\.([^.]+))?$/;
                const fileExtension = re.exec(this.files[0].name)[1];
                const fileSize = Math.round(this.files[0].size / 1024); // in KB

                if (fileExtension.toLowerCase() !== "csv") {
                    this.invalidFileExt = true;
                } else if (fileSize > 102400) {
                    // 100 MB
                    this.largeFile = true;
                } else {
                    this.uploadStarted = true;
                    this.invalidFileExt = false;
                    this.largeFile = false;

                    const file = this.files[0];
                    const reader = new FileReader();
                    reader.onabort = () => {
                        console.log(
                            "File reading aborted for some reason, Please try again"
                        );
                    };
                    reader.onerror = (err) => {
                        console.log("file reading has failed", err);
                    };
                    reader.onload = async () => {
                        // For client_admin or client_users
                        if (
                            storeData.currentUserDetails.role.name ===
                            "client_admin" ||
                            storeData.currentUserDetails.role.name ===
                            "client_user"
                        ) {
                            this.selectedClient =
                                storeData.currentUserDetails.client_id;
                        }

                        //** todo temp hardcode client id for test */
                        if (this.type === "opportunity-data") {
                            this.selectedClient = "a8361072-903b-444f-b5d3-5e8c02d0db18";
                        }


                        let uploadFiles = new UploadFiles();

                        const uploadRes = await uploadFiles.init(
                            reader.result,
                            file,
                            this.type,
                            this.selectedClient
                        );
                        if (uploadRes) {
                            // Add file status to db
                            this.$apollo
                                .mutate({
                                    mutation: FILE_UPLOAD_STATUS,
                                    variables: {
                                        fileName: file.name,
                                        type: this.type,
                                        client_id: this.selectedClient,
                                        created_on: _.getUTCTimestamp(),
                                    },
                                })
                                .then((res) => {
                                    const result =
                                        res.data
                                            .insert_spendmd_db_file_upload_status
                                            .returning;
                                    if (result[0].id > 0)
                                        console.log("file upload status added");
                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                        } else {
                            // Show failed response in modal
                        }
                    };
                    reader.readAsArrayBuffer(file);
                }
            }
        },
        handleClose() {
            this.importModal = false;
            this.reset();
            this.$emit("close");
        },
        reset() {
            if (document.getElementById("select"))
                document.getElementById("select").selectedIndex = 0;
            document.getElementById("fileInput").value = "";
            this.uploadStarted = false;

            this.files = null;
            this.selectedClient = null;
            this.invalidFileExt = false;
            this.largeFile = false;
        },
    },
    async beforeMount() {
        this.importModal = false;

        this.clientList = [];
        const res = await this.$apollo.mutate({
            mutation: GET_CLIENTS_LIST,
        });

        const result = res.data.spendmd_db_clients;
        for (const el of result) {
            this.clientList.push({
                label: el.name,
                value: el.id,
            });

        }
        // For client_admin or client_users
        if (
            storeData.currentUserDetails.role.name === "client_admin" ||
            storeData.currentUserDetails.role.name === "client_user"
        ) {
            this.selectedClient = storeData.currentUserDetails.client_id;
        }

    },
};

const PROJECT_TEMPLATE = {
    name: "",
    project_number: "",
    prime_category: "",
    secondary_category: "",
    sub_category: "",
    anticipated_project_closure: "",
    spendmd_opportunity: "",
    savings_target: "",
    project_start: "",
    project_end: "",
    target_date: "",
    status: "",
};
const SPEND_DATA_TEMPLATE = {
    spend_id: "",
    comp_code: "",
    cp_loc_code: "",
    remit_to_name: "",
    doc_date: "",
    doc_status: "",
    ext_doc_no: "",
    pay_type_code: "",
    apbatch_no: "",
    processed_date: "",
    inv_no: "",
    inv_date: "",
    inv_du_date: "",
    reversal_date: "",
    vend_gp_code: "",
    eft_process_date: "",
    doc_curr_code: "",
    strt_ln1: "",
    strt_ln2: "",
    strt_ln3: "",
    loc_govt: "",
    country_code: "",
    post_code: "",
    stat_govt: "",
    cash_tran_id: "",
    func_disc_amt: "",
    func_appld_amt: "",
    net_amount: "",
    func_doc_amt: "",
    change: "",
};
const VENDOR_TEMPLATE = {
    vendor_name: "",
    normal_name: "",
    prime_category: "",
    secondary_category: "",
    sub_category: "",
};
const CATEGORY_WISE_OPPORTUNITY_TEMPLATE = {
    goal_name: "",
    prime_category: "",
    secondary_category: "",
    sub_category: "",
    opportunity: "",
    goal: "",
    created_at: "",
};
const CATEGORIES_TEMPLATE = {
    prime_category: "",
    secondary_category: "",
    sub_category: "",
};
const OPPORTUNITY_TEMPLATE = {
    prime_category: "",
    secondary_category: "",
    sub_category: "",
};
const ITEMS_TEMPLATE = {
    project_number: "",
    client: "",
    group: "",
    category: "",
    vendor_name: "",
    vendor_catalog: "",
};
</script>

<style>
.custom-col {
    padding-left: 10px;
    padding-top: 0px;
}

.custom-col1 {
    padding-left: 10px;
    padding-top: 15px;
    padding-bottom: 5px;
}

.error {
    color: #ff6700;
}
</style>
